export default function BrandWordmark({ hero = false }: { hero?: boolean }) {
  return (
    <span className={`brand-wordmark${hero ? ' brand-wordmark-hero' : ''}`}>
      <span className="brand-dj">DJ</span>{' '}
      <span className="brand-name">PARDESI</span>
    </span>
  )
}
